import { Text } from './components/core/text/Text'
import s from './styles/pages/Podcast.module.scss'

export default [
    {
        uid: 'sera-jona-hronn-bolladottir',
        title: 'Séra Jóna Hrönn Bolladóttir talar um Séra Bolla Þóri Gústavsson',
        paragraph:
            'Í þessum fyrsta þætti ræðir Sirrý Arnardóttir við séra Jónu Hrönn Bolladóttur um pabba hennar séra Bolla Þóri Gústavsson.',
        date: '2022-04-14T12:00:00+0000',
        description: (
            <div>
                <Text>
                    Sirrý Arnardóttir ræðir við dóttur{' '}
                    <a href="http://minningar.is/memories/bolli-thorir-gustavsson-1935-2008">
                        séra Bolla Þóris Gústavssonar
                    </a>
                    , prests, vígslubiskups, myndlistarmanns og rithöfundar.
                    Séra Jóna Hrönn Bolladóttir stiklar á stóru í viðburðaríkri
                    ævi föður síns og deilir minningum sínum um persónuleika
                    hans og lífshlaup.
                </Text>
            </div>
        ),
        length: '28 mín',
        videoId: 699088824,
        spotify:
            'https://open.spotify.com/episode/5XJic9lRf4LzwHFMm3laev?si=039bf5ae060d45b9',
        google: 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8xOTcxODg4LnJzcw/episode/QnV6enNwcm91dC0xMDQyNjUwNQ?sa=X&ved=0CAUQkfYCahcKEwjgyLLWitz3AhUAAAAAHQAAAAAQPQ',
        youtube: 'https://www.youtube.com/watch?v=Tpx2W8mU93c',
        playlistImage:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FJona_playlist.png?alt=media&token=5ea16c62-9f52-45e7-b410-e2b2513b500b',
        thumbnail:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FJona.png?alt=media&token=d76dc44a-f68b-422a-b964-bcb6ad8e17c9',
    },
    {
        uid: 'thorarinn-eldjarn',
        title: 'Þórarinn Eldjárn talar um Halldóru Eldjárn',
        paragraph:
            'Sirrý ræðir við Þórarinn Eldjárn um móður hans Halldóru Eldjárn, fyrrverandi forsetafrú. Hann deilir minningum sínum um hana og lýsir perónuleika hennar og uppeldisaðferðum. Hann ráðleggur einnig öllu ungu fólki að yfirheyra eldri kynslóðina til að minningar og sögur þeirra tapist ekki, og talar í því samhengi um mikilvægi að Minningar.is.',
        date: '2022-04-21T12:00:00+0000',
        description: (
            <div>
                <Text>
                    Sirrý ræðir við Þórarinn Eldjárn um móður hans{' '}
                    <a href="/memories/halldora-kristin-ingolfsdottir-eldjarn-1923-2008">
                        Halldóru Eldjárn
                    </a>
                    , fyrrverandi forsetafrú. Hann deilir minningum sínum um
                    hana og lýsir perónuleika hennar og uppeldisaðferðum. Hann
                    ráðleggur einnig öllu ungu fólki að yfirheyra eldri
                    kynslóðina til að minningar og sögur þeirra tapist ekki, og
                    talar í því samhengi um mikilvægi að Minningar.is.
                </Text>
            </div>
        ),
        length: '34 mín',
        videoId: 701489677,
        spotify:
            'https://open.spotify.com/episode/0UbOXXCUOU7q0TzaN08hnj?si=7101f75b12584ff1',
        google: 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8xOTcxODg4LnJzcw/episode/QnV6enNwcm91dC0xMDQ4NDY0Nw?sa=X&ved=0CAUQkfYCahcKEwjgyLLWitz3AhUAAAAAHQAAAAAQPQ',
        youtube: 'https://www.youtube.com/watch?v=RNaCUtdp-18',
        playlistImage:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FThorarinn.png?alt=media&token=0f082f31-48d9-4d45-8911-79b67d33b920',
        thumbnail:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FThorarinn.png?alt=media&token=0f082f31-48d9-4d45-8911-79b67d33b920',
    },
    {
        uid: 'helma-thorsteinsdóttir',
        title: 'Helma Þorsteinsdóttir talar um Þorstein Sæmundsson',
        paragraph:
            'Sirrý ræðir við Helmu Þorsteinsdóttur um pabba hennar, Þorstein Sæmundsson flugvirkja. Hún stiklar á stóru í ævi hans og lýsir á skemmtilegan hátt sambandi þeirra mæðgina. Hún gefur innsýn inn í hvernig það er að missa ástvin úr sjálfsvígi og talar um hvernig stuðningur við aðstandendur hefur þróast til hins betra á undanförnum árum. ',
        date: '2022-04-28T12:00:00+0000',
        description: (
            <div>
                <Text>
                    Sirrý ræðir við Helmu Þorsteinsdóttur um pabba hennar,{' '}
                    <a href="/memories/thorsteinn-saemundsson-1945-2016">
                        Þorstein Sæmundsson
                    </a>{' '}
                    flugvirkja. Hún stiklar á stóru í ævi hans og lýsir á
                    skemmtilegan hátt sambandi þeirra mæðgina. Hún gefur innsýn
                    inn í hvernig það er að missa ástvin úr sjálfsvígi og talar
                    um hvernig stuðningur við aðstandendur hefur þróast til hins
                    betra á undanförnum árum.
                </Text>
            </div>
        ),
        length: '26 mín',
        videoId: 704115421,
        spotify:
            'https://open.spotify.com/episode/2yaITtp489HuOM1RMbCasS?si=c1bdef2dcd13434d',
        google: 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8xOTcxODg4LnJzcw/episode/QnV6enNwcm91dC0xMDUxNDg5Mw?sa=X&ved=0CAUQkfYCahcKEwjgyLLWitz3AhUAAAAAHQAAAAAQPQ',
        youtube: 'https://www.youtube.com/watch?v=9zkbIxmDBQU',
        playlistImage:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2Fhelma_playlist.png?alt=media&token=94237adb-68a1-4954-8257-c60ec385736a',
        thumbnail:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2Fhelma_thumbnail.png?alt=media&token=f507d3be-869c-4888-a750-1779bd041d3e',
    },

    {
        uid: 'kristjan-gislason',
        title: 'Kristján Gíslason talar um Gísla Kristjánsson',
        paragraph:
            'Sirrý ræðir við Kristján Gíslason um pabba hans Gísla Kristjánsson vélstjóra og tæknilegs ráðgjafa og listamanns. Hann lýsir persónulegum einkennum pabba síns, og rifjar upp minningar af metnaðarfullri kassabílagerð og gosbrunnasmíði.  Hann deilir sögum frá mörgum skeiðum í ævi Gísla, á lifandi og skemmtilegan hátt.',
        date: '2022-05-05T12:00:00+0000',
        description: (
            <div>
                <Text>
                    Sirrý ræðir við Kristján Gíslason um pabba hans Gísla
                    Kristjánsson vélstjóra og tæknilegs ráðgjafa og listamanns.
                    Hann lýsir persónulegum einkennum pabba síns, og rifjar upp
                    minningar af metnaðarfullri kassabílagerð og gosbrunnasmíði.
                    Hann deilir sögum frá mörgum skeiðum í ævi Gísla, á lifandi
                    og skemmtilegan hátt.
                </Text>
            </div>
        ),
        length: '25 mín',
        videoId: 706538272,
        spotify:
            'https://open.spotify.com/episode/1H82Sh5ni1gi1F6oIG4j2u?si=0acbddd018254a15',
        google: 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8xOTcxODg4LnJzcw/episode/QnV6enNwcm91dC0xMDU2NDI4MQ?sa=X&ved=0CAUQkfYCahcKEwjgyLLWitz3AhUAAAAAHQAAAAAQPQ',
        youtube: 'https://www.youtube.com/watch?v=m8Hd-peCrW0',
        playlistImage:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FKristjan_playlist.png?alt=media&token=b374a8ad-fd8c-402f-83a8-ad4c556af180',
        thumbnail:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FKristjan_thumb_1.png?alt=media&token=246900af-3091-4987-b156-6602eed5ff3d',
    },
    {
        uid: 'bergljot-rist',
        title: 'Bergljót Rist talar um Sigurjón Rist',
        paragraph:
            'Í fimmta þætti talar Bergljót Rist um föður sinn Sigurjón Rist vatnamælingamann.',
        date: '2022-05-12T12:00:00+0000',
        description: (
            <Text>
                Í fimmta þætti talar Bergljót Rist um föður sinn
                <a href="/memories/sigurjon-rist-1917-1994"> Sigurjón Rist </a>
                vatnamælingamann. Sigurjón var frumkvöðull sem hafði brennandi
                áhuga á vatnsafli, rafmagni og tækni, ásamt því að vera mikill
                náttúruunnandi.
            </Text>
        ),
        length: '27 mín',
        videoId: 709005547,
        spotify:
            'https://open.spotify.com/episode/2hMR7ne2NKnFWu2ZXqC7DT?si=6dad4b287d684bd1',
        google: 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8xOTcxODg4LnJzcw/episode/QnV6enNwcm91dC0xMDYwNTI5Ng?sa=X&ved=0CAUQkfYCahcKEwjgyLLWitz3AhUAAAAAHQAAAAAQPQ',
        youtube: 'https://www.youtube.com/watch?v=glTaA472Hnw',
        playlistImage:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FBergljot_playlist.jpg?alt=media&token=bdd87dfc-4a6f-4f68-9224-33660ae75853',
        thumbnail:
            'https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/podcast%2FBergljot_thumb.jpg?alt=media&token=acdb21fa-ef42-47e3-a08a-7f9ef4aaf439',
    },
]
